import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { GlobalService } from "../global.service";
import { catchError, map, tap } from "rxjs/operators";
import { CreditActivityService } from "../credit-activity.service";
import { TransactionService } from "../transaction.service";
const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})

export class TeamManagementService {

  constructor(
    private http: HttpClient,
    private creditActivityService: CreditActivityService,
    private transactionService: TransactionService
  ) { }

  /**
   * Fetch all the invite team members
   * @param index 
   * @returns 
   */
  fetchallteaminvites(index: string) {
    let url = devUrl + "/team/fetchallteaminvites";
    let params = new HttpParams().set('startindex', index);
    return this.http.get(url, { params }).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('fetchteaminvitelink', url)));
  };

  /**
   * Send Invite to candidate
   * @param data 
   * @returns 
   */
  sendteaminviteviaemail(data: any) {
    var url = devUrl + "/team/sendteaminviteviaemail"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('sendteaminviteviaemail', url)));
  }



  /**
   * Remove Team Members
   * @param data 
   * @returns 
   */
  removemember(data: any) {
    const url = devUrl + "/team/removemember";
    return this.http.post(url, data).pipe(
      map(response => { return response; }),
      // removing a member releases their reserved credits back to the pool - refresh the admin's
      // own credit balance so it doesn't stay stuck at the pre-removal value
      tap(() => { this.creditActivityService.notifyCreditConsumed(); }),
      catchError(GlobalService.handleError('Remove Team Member', url)));
  };

  /**
  * Remove Team Members
  * @param data
  * @returns
  */
  updateCredit(data: any) {
    var url = devUrl + "/team/updatecontactenrichmentcredits"
    return this.http.post(url, data).pipe(
      map(response => { return response; }),
      // reallocates credits between admin/team member - refresh so the new balance shows immediately
      tap(() => { this.creditActivityService.notifyCreditConsumed(); }),
      catchError(GlobalService.handleError('Update Candidate Credits', url)));
  };


  /**
   * Revoke Candidate Invitation
   * @param data 
   * @returns 
   */
  revokeCandidateInvitation(data: any) {
    const url = devUrl + "/team/revokeinvitation";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Revoke Invitation', url)))
  };

  /**
   * Get invite link to invite team member
   * @returns 
   */
  fetchteaminvitelink() {
    let url = devUrl + "/team/fetchteaminvitelink"
    return this.http.get(url).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('fetchteaminvitelink', url)));
  };


  /**
 * Fetch User All Remind Later Invites
 * @returns 
 */
  fetchUserRemindLaterInvites() {
    let url = devUrl + "/team/snoozedinvites"
    return this.http.get(url).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('Fetch User All Remind Later Invites', url)));
  };



  /**
   * Reserver Credit for admin
   * @param data 
   * @returns 
   */
  reserveAdminCredit(data: any) {
    let url = devUrl + "/team/reserveadmincredits"
    return this.http.post(url, data).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('fetchteaminvitelink', url)));

  };

  /**
   * Add credit to team pool
   * @param data 
   * @returns 
   */
  addCreditToTeamPool(data: any) {
    let url = devUrl + "/team/addcreditstopool"
    return this.http.patch(url, data).pipe(
      map(response => { return response; }),
      // refresh so "Available Team Credits" reflects the newly added balance immediately
      tap(() => { this.creditActivityService.notifyCreditConsumed(); }),
      catchError(GlobalService.handleError('Add Credits To Team Pool', url)));
  };

  /**
   * Store Activity for create team credit pool
   * @param data 
   * @returns 
   */
  createTeamCreditPool(data: any) {
    const url = devUrl + "/team/creditpool";
    return this.http.post(url, data).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('Create Team Credit Pool', url)));
  };


  /**
   * Fetch user all activity
   * @param usernumber 
   * @returns 
   */
  fetchUserActivity(usernumber: any) {
    const url = devUrl + "/team/usercreditactivity";
    const params = new HttpParams().set('usernumber', usernumber)
    return this.http.get(url, { params }).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('Fetch User Activity', url)));
  };


  /**
   * Invitation Response
   * @param data 
   * @returns 
   */
  teamInviteResponse(data: any) {
    var url = devUrl + "/team/inviteresponse"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('inviteresponse', url)));
  };


  /**
  * Invitation Response
  * @param data 
  * @returns 
  */
  remindLater(data: any) {
    var url = devUrl + "/team/snoozeinvite"
    return this.http.patch(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('inviteresponse', url)));
  };

/**
 * Transfer the Admin role to an existing active team member.
 * Team members are loaded via `fetchallteaminvites`; no extra API call is needed.
 * @param data - { usernumber: string, targetUserId: number, operatorIdentifier: string }
 * @returns
 */
  transferAdmin(data: any) {
    const url = devUrl + "/team/transferadmin";
    return this.http.post(url, data).pipe(
      map(response => { return response; }),
      // the caller's own role/credits/access all change here (admin -> team member) - refresh
      // both, and force-bypass the access cache since role-driven flags (autopilot etc.) just changed
      tap(() => {
        this.creditActivityService.notifyCreditConsumed();
        this.transactionService.updateAccessDetailsForCurrentUser(true).subscribe();
      }),
      catchError(GlobalService.handleError('Transfer Admin', url)));
  };

}